/* Native Weglot API, also for drawer nodes rendered after initialization. */
(() => {
  const selector = '[data-doriante-language]';
  let connected = false;
  let attempts = 0;
  function update() {
    const current = window.Weglot?.getCurrentLang?.();
    if (!['it', 'en'].includes(current)) return false;
    document.documentElement.classList.add('doriante-language-ready');
    document.querySelectorAll(selector).forEach(link => {
      link.setAttribute('aria-current', String(link.dataset.dorianteLanguage === current));
    });
    return true;
  }
  function connect() {
    if (typeof window.Weglot?.switchTo !== 'function' || !window.Weglot.initialized) return false;
    if (!connected) {
      connected = true;
      window.Weglot.on('languageChanged', update);
      document.addEventListener('shopify:section:load', update);
      const header = document.querySelector('header-component');
      if (header) new MutationObserver(update).observe(header, { childList: true, subtree: true });
      document.addEventListener('click', event => {
        const link = event.target.closest?.(selector);
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        try {
          window.Weglot.switchTo(link.dataset.dorianteLanguage);
        } catch {
          document.documentElement.classList.remove('doriante-language-ready');
        }
      }, true);
    }
    return update();
  }
  if (!connect()) {
    const timer = window.setInterval(() => {
      attempts += 1;
      if (connect() || attempts >= 50) window.clearInterval(timer);
    }, 300);
  }
})();
